import { gql } from '@apollo/client'

const CREATE_CONTACT = gql`
  mutation CreateContact($documentNumber: ID!, $contact: ContactInput!) {
    createContact(documentNumber: $documentNumber, contact: $contact) {
      message
      statusCode
      code
      error
    }
  }
`

export default CREATE_CONTACT
